export const SEARCH_RESULTS_PAGE_ID = 'SEARCH_RESULTS';
export const SEARCH_RESULTS_MAX_WIDTH = 1200;
export const MAX_SEARCH_DROPDOWN_RESULTS = 3;
export const MIN_TYPE_TO_SEARCH_QUERY_LENGTH = 3;
export const DEBOUNCED_SEARCH_INPUT_TIME = 250;
export const SEARCH_DROPDOWN_DESKTOP_WIDTH = 498;
export const ALERT_CONTAINER_MAX_WIDTH = 800;